module.exports = __webpack_public_path__ + "img/tooth.2c6caac8.svg";